const assets = {
  COINMILES_LOGO: require("./logo.png"),
  COINMILES_LOGO_W: require("./logo-white.png"),

  CATEGORY_IMAGE_BEAUTY: require("./beauty.png"),
  CATEGORY_ICON_BEAUTY: require("./beauty-icon.png"),
  CATEGORY_CIRCULAR_ICON_BEAUTY: require("./beauty-icon-circular.png"),

  CATEGORY_IMAGE_FOOD_AND_DRINKS: require("./food-and-drinks.png"),
  CATEGORY_ICON_FOOD_AND_DRINKS: require("./food-and-drinks-icon.png"),
  CATEGORY_CIRCULAR_ICON_FOOD_AND_DRINKS: require("./food-and-drinks-icon-circular.png"),

  CATEGORY_IMAGE_THINGS_TO_DO: require("./things-to-do.png"),
  CATEGORY_ICON_THINGS_TO_DO: require("./things-to-do-icon.png"),
  CATEGORY_CIRCULAR_ICON_THINGS_TO_DO: require("./things-to-do-icon-circular.png"),

  CATEGORY_IMAGE_SERVICES: require("./services.png"),
  CATEGORY_ICON_SERVICES: require("./services-icon.png"),
  CATEGORY_CIRCULAR_ICON_SERVICES: require("./services-icon-circular.png"),

  COINMILES_SQUARE_LOGO: require("./coinmiles-square-logo.png"),
  COINMILES_SQUARE_LOGO_NO_CORNERS: require("./coinmiles-square-logo-no-corners.png"),
  CREDIT_CARD: require("./credit-card.png"),
  DELETE_CARD: require("./delete-card-icon.png"),
  DIRECT_HIT: require("./direct-hit.png"),
  FALLING_COINS: require("./falling-coins.jpg"),
  FALLING_COINS_WIDE: require("./falling-coins-wide.jpg"),
  GIFT_EMOJI: require("./gift-emoji.png"),
  GIFT_BOX: require("./gift-box.png"),
  HOTELS_WALLET_ICON: require("./wallet-icon.png"),
  INTERAC_LOGO: require("./interac-logo.png"),
  MAIL_ICON: require("./mail.png"),
  MOBILE_DEVICE_BACKGROUND: require("./mobile-device-background.png"),
  MONEY_BAG: require("./money-bag.png"),
  NO_ENTRY: require("./no-entry.png"),
  PARTY_POPPER: require("./party-popper.png"),
  RIGHT_POINT: require("./right-point.png"),
  ROCK_EMOJI: require("./rock-emoji.png"),
  REFERRAL_LOGO: require("./referral-logo.png"),
  ROCKET_EMOJI: require("./rocket-emoji.png"),
  SHOPPING_BAGS: require("./shopping-bags.png"),
  STAR_EYES_EMOJI: require("./star-eyes-emoji.png"),
  SUCCESS_CONFETTI: require("./success-confetti.png"),
  WAVE_EMOJI: require("./wave-emoji.png"),
  WITHDRAWAL_ICON: require("./send.png"),
  WELCOME_GIFT: require("./welcome-bonus.png"),

  ACTIVITIES_EVENTS: require("./activities_events.png"),
  ALL: require("./star-eyes-emoji.png"),
  ARROW_DOWN: require("./arrow-down.png"),
  ARROW_UP: require("./arrow-up.png"),
  BABY_KIDS: require("./baby-kids.png"),
  BEAUTY_WELLNESS: require("./beauty-wellness.png"),
  EDUCATION: require("./education.png"),
  ELECTRONICS: require("./electronics.png"),
  FINANCE_CRYPTO: require("./finance-crypto.png"),
  FOOD_GROCERY: require("./food-grocery.png"),
  HOME_GARDEN: require("./home-garden.png"),
  HOTEL_TRAVEL: require("./hotel-travel.png"),
  LUXURY: require("./luxury.png"),
  MENS: require("./mens.png"),
  PIN_ICON: require("./map-pin-2x.png"),
  PLANE_ICON: require("./plane-2x.png"),
  SPORTS_OUTDOOR: require("./sports-outdoor.png"),
  USER_ICON: require("./user-2x.png"),
  WOMENS: require("./womens.png"),
};

export { assets as Assets };
